// extracted by mini-css-extract-plugin
export default {"root":"AmountStrip_root__KZ1iu","value":"AmountStrip_value__+5Yi5"};